import BasePresenter from '@src/js/separate-logic/base-presenter';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { dispatchProps } from '@src/js/separate-logic/decorate/dispatchProps';
import { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';

export default class ScaleElementWrapperPresenter extends BasePresenter {
    @dispatchProps()
    public getMediaManager(): IMediaManager | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
            .viewableServiceLayer.mediaManager;
    }
}
